import React, { Fragment } from 'react';
import { useParams } from 'react-router-dom';
import NavbarS4 from '../../components/NavbarS4/NavbarS4';
import PageTitle from '../../components/pagetitle/PageTitle';
import Services from '../../api/Services';
import ScrollTextAnimation from '../../components/ScrollTextAnimation/ScrollTextAnimation';
import PartnerSection from '../../components/PartnerSection/PartnerSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import VideoModal from '../../components/ModalVideo/VideoModal';
import Logo from '../../images/logo.jpeg';

/* ===== BACKGROUND VIDEO IMAGES FOR EACH SERVICE ===== */
import bg1 from '../../images/wpo-video.jpg';
import bg2 from '../../images/intbgv1.jpg';
import bg3 from '../../images/des.jpg';
import bg4 from '../../images/land.jpg';

/* ===== DREAM IMAGES FOR EACH SERVICE ===== */
// Architectural service images
import arch1 from '../../images/service-single/dream/arc1.jpg';
import arch2 from '../../images/service-single/dream/arc2.jpg';
import arch3 from '../../images/service-single/dream/arc3.jpg';
import arch4 from '../../images/service-single/dream/arc4.jpg';

// Interiors service images
import interior1 from '../../images/service-single/dream/int1.jpg';
import interior2 from '../../images/service-single/dream/int2.jpg';
import interior3 from '../../images/service-single/dream/int3.jpg';
import interior4 from '../../images/service-single/dream/int4.jpg';

// Design & Planning service images
import design1 from '../../images/service-single/dream/des1.jpg';
import design2 from '../../images/service-single/dream/des2.jpg';
import design3 from '../../images/service-single/dream/des3.jpg';
import design4 from '../../images/service-single/dream/des4.jpg';

// Landscaping service images
import landscape1 from '../../images/service-single/dream/land1.jpg';
import landscape2 from '../../images/service-single/dream/land2.jpg';
import landscape3 from '../../images/service-single/dream/land3.jpg';
import landscape4 from '../../images/service-single/dream/land4.jpg';

import TestimonialS4 from '../../components/TestimonialS4/TestimonialS4';

const ServiceSinglePage = () => {
  const { slug } = useParams();
  const serviceSingle = Services.find(item => item.slug === slug);

  /* ===== SERVICE-WISE BACKGROUND IMAGES ===== */
  const serviceBgImages = {
    architectural: bg1,
    interiors: bg2,
    'design-planning': bg3,
    Landscaping: bg4
  };

  /* ===== SERVICE-WISE DREAM IMAGES ===== */
  const serviceDreamImages = {
    architectural: {
      dream1: arch1,
      dream2: arch2,
      dream3: arch3,
      dream4: arch4
    },
    interiors: {
      dream1: interior1,
      dream2: interior2,
      dream3: interior3,
      dream4: interior4
    },
    'design-planning': {
      dream1: design1,
      dream2: design2,
      dream3: design3,
      dream4: design4
    },
    Landscaping: {
      dream1: landscape1,
      dream2: landscape2,
      dream3: landscape3,
      dream4: landscape4
    }
  };

  /* ===== SERVICE-WISE CONTENT (ONLY 4 SERVICES) ===== */
  const serviceContent = {
    architectural: {
      p1: `YV Reddy Associates provides comprehensive architectural services for residential, commercial, and institutional projects across diverse sectors. Our architectural approach focuses on creating structurally sound, functional, and visually compelling buildings that meet regulatory standards and client expectations. We emphasize intelligent planning, spatial efficiency, and long-term sustainability in every design. By understanding site conditions, user requirements, and project constraints, we develop solutions that are both practical and innovative. Each project is handled with meticulous attention to detail to ensure durability, safety, and design integrity throughout its lifecycle.`,

      p2: `Our architectural services cover the entire project journey, including concept development, schematic design, detailed drawings, statutory approvals, and coordination during execution. We work closely with engineers, consultants, and contractors to ensure seamless integration between design intent and construction realities. Through careful documentation and technical coordination, we minimize risks, control costs, and maintain project timelines. Our goal is to deliver architecture that not only meets today's needs but remains relevant and adaptable for the future.`,

      dreamTitle: 'Building Strong Architectural Foundations',
      dreamDesc: `Every successful project begins with a strong architectural foundation. At YV Reddy Associates, we believe architecture is the balance of creativity, engineering, and purpose. Our designs aim to enhance usability while maintaining aesthetic appeal and structural reliability. By combining innovative thinking with proven construction practices, we create buildings that stand the test of time and add lasting value to the built environment.`,

      passionTitle: 'Architecture Guided by Expertise',
      passionDesc: `Our architectural expertise is driven by years of hands-on experience, technical knowledge, and a deep understanding of industry standards. We approach each project with precision planning, clear communication, and a commitment to quality. This ensures smooth execution, reduced uncertainties, and outcomes that align perfectly with client goals and functional requirements.`,
    },

    interiors: {
      p1: `Interiors specializes in delivering high-quality interior solutions for corporate, commercial, and residential spaces. Our interior designs are focused on creating environments that enhance productivity, comfort, and visual appeal. We carefully consider space planning, movement flow, lighting, and material selection to ensure every interior is both functional and aesthetically refined. By aligning design concepts with client branding and operational needs, we create spaces that feel purposeful and well-organized.`,

      p2: `From initial design concepts to final execution, our interior services are managed by an experienced team of designers, engineers, and project managers. We offer turnkey solutions that include layout planning, finishes selection, furniture integration, and on-site coordination. Our attention to detail and quality craftsmanship ensures superior finishes and long-lasting performance. With a strong focus on timelines and budgets, we deliver interiors that exceed expectations without compromising efficiency.`,

      dreamTitle: 'Designing Inspiring Interior Spaces',
      dreamDesc: `Great interiors go beyond appearance—they shape experiences and influence how people work and live. Our interior designs are crafted to inspire creativity, improve efficiency, and create a sense of comfort. By blending aesthetics with practicality, we deliver spaces that feel balanced, welcoming, and purpose-driven.`,

      passionTitle: 'Interiors Crafted with Precision',
      passionDesc: `Each interior project reflects our dedication to precision, quality materials, and thoughtful detailing. We coordinate every element carefully to ensure seamless execution and consistent results. Our passion lies in transforming empty spaces into functional, elegant environments that truly serve their intended purpose.`,
    },

    'design-planning': {
      p1: `Our Design & Planning services focus on transforming ideas into well-structured, efficient, and executable solutions. We emphasize intelligent space utilization, workflow optimization, and technical feasibility from the earliest planning stages. By studying user requirements, site conditions, and project objectives, we develop layouts that maximize efficiency and minimize wastage. Our planning process ensures clarity, functionality, and adaptability across all types of projects.`,

      p2: `We integrate design thinking with technical coordination to bridge the gap between concept and execution. Our planning services include layout optimization, material strategy, cost considerations, and coordination with engineering disciplines. This structured approach helps reduce rework, control budgets, and streamline project execution. With careful planning at every stage, we ensure projects are delivered smoothly, efficiently, and with predictable outcomes.`,

      dreamTitle: 'Smart Planning for Smarter Spaces',
      dreamDesc: `Effective planning is the foundation of every successful project. Our design and planning solutions ensure that spaces are not only visually appealing but also practical, efficient, and future-ready. Through thoughtful layouts and strategic coordination, we help bring clarity and direction to complex projects.`,

      passionTitle: 'Planning that Drives Performance',
      passionDesc: `Our planning expertise enables better decision-making, smoother execution, and optimized results. By aligning design intent with technical feasibility, we ensure that every project performs efficiently from concept through completion.`,
    },

    Landscaping: {
      p1: `Landscaping Services offers complete outdoor design and development solutions that enhance the overall environment of a project. Our landscaping approach focuses on creating visually appealing, functional, and sustainable outdoor spaces. We carefully plan layouts, plant selection, and hardscape elements to complement the surrounding architecture. Each design considers climate conditions, maintenance requirements, and long-term usability.`,

      p2: `From concept planning to execution, we deliver landscaping solutions for residential, commercial, and institutional projects. Our services include landscape design, plant sourcing, installation, and coordination of outdoor elements. By combining aesthetic sensibility with environmental responsibility, we create landscapes that are both beautiful and practical. Our goal is to enhance outdoor experiences while maintaining ecological balance.`,

      dreamTitle: 'Creating Harmonious Outdoor Spaces',
      dreamDesc: `Outdoor spaces play a vital role in shaping the overall character of a project. Our landscaping solutions are designed to create harmony between built structures and natural elements. Thoughtful design and execution ensure inviting, functional, and sustainable outdoor environments.`,

      passionTitle: 'Landscaping with Purpose',
      passionDesc: `We approach landscaping with care, creativity, and responsibility. Our focus is on delivering outdoor spaces that enhance visual appeal, support usability, and contribute positively to the surrounding ecosystem.`,
    },
  };

  const content = serviceContent[slug];
  const currentBgImage = serviceBgImages[slug] || bg1;
  const currentDreamImages = serviceDreamImages[slug] || serviceDreamImages.architectural;

  return (
    <Fragment>
      <NavbarS4
        hclass={'wpo-site-header wpo-header-style-s11'}
        Logo={Logo}
        col1={'col-lg-3 col-md-3 col-3 d-lg-none dl-block'}
        col2={'col-lg-2 col-md-4 col-6'}
        col3={'col-lg-7 col-md-1 col-1'}
        col4={'col-lg-3 col-md-4 col-2'}
      />

      <PageTitle pageTitle={serviceSingle?.title} pagesub={'Services'} />
      <ScrollTextAnimation />

      {/* ===== SERVICE CONTENT ===== */}
      <section className="service-single-page">
        <div className="container-fluid">
          <div
            className="service-image scroll-text-animation"
            data-animation="fade_from_bottom"
          >
            <img src={serviceSingle?.SImg} alt="" />
          </div>

          <div className="row align-items-center">
            <div className="col-lg-8 col-12">
              <div className="content">
                <h2
                  className="scroll-text-animation"
                  data-animation="fade_from_bottom"
                >
                  {serviceSingle?.title}
                </h2>

                <p>{content?.p1}</p>
                <p>{content?.p2}</p>
              </div>
            </div>

            <div className="col-lg-4 col-12">
              <div
                className="video"
                style={{ backgroundImage: `url(${currentBgImage})` }}
              >
                <div className="video-holder">
                  <VideoModal />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== DREAM SECTION ===== */}
      <section className="dream-section">
        <div className="container-fluid">
          <div className="dream-wrap">
            <div className="title">
              <h2>{content?.dreamTitle}</h2>
              <p>{content?.dreamDesc}</p>
            </div>

            <div className="image-wrap">
              <div className="row">
                <div
                  className="col-lg-6 col-md-6 col-12 scroll-text-animation"
                  data-animation="fade_from_bottom"
                >
                  <div className="image">
                    <img src={currentDreamImages.dream1} alt="" />
                  </div>
                </div>
                <div
                  className="col-lg-6 col-md-6 col-12 scroll-text-animation"
                  data-animation="fade_from_bottom"
                >
                  <div className="image">
                    <img src={currentDreamImages.dream2} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== PASSION SECTION ===== */}
      <section className="service-business section-padding">
        <div className="container-fluid">
          <div className="project-title">
            <div className="row align-items-center">
              <div className="col-lg-6 col-12">
                <h2
                  className="scroll-text-animation"
                  data-animation="fade_from_bottom"
                >
                  {content?.passionTitle}
                </h2>
              </div>

              <div className="col-lg-6 col-12">
                <p
                  className="scroll-text-animation"
                  data-animation="fade_from_bottom"
                >
                  {content?.passionDesc}
                </p>
              </div>
            </div>
          </div>

          <div className="image-wrap">
  <div className="row">

    <div className="col col-lg-6 col-md-12 col-12">
      <div
        style={{
          width: "100%",
          height: "460px",
          position: "relative",
          overflow: "hidden"
        }}
      >
        <img
          src={currentDreamImages.dream3}
          alt=""
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            width: "100%",
            height: "100%",
            transform: "translate(-50%, -50%)",
            objectFit: "cover"
          }}
        />
      </div>
    </div>

    <div className="col col-lg-6 col-md-12 col-12">
      <div
        style={{
          width: "100%",
          height: "460px",
          position: "relative",
          overflow: "hidden"
        }}
      >
        <img
          src={currentDreamImages.dream4}
          alt=""
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            width: "100%",
            height: "100%",
            transform: "translate(-50%, -50%)",
            objectFit: "cover"
          }}
        />
      </div>
    </div>

  </div>
</div>

        </div>
      </section>

      <TestimonialS4 hclass={'wpo-testimonial-section-s3 section-padding'} />
      <PartnerSection hclass={'wpo-partners-section fade_bottom'} />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default ServiceSinglePage;